export const BREAKPOINTS = {
  s: "(max-width: 30em)",
  ns: "(min-width: 30em)",
  m: "(min-width: 30em) and (max-width: 60em)",
  l: "(min-width: 60em)",
};
